export default __webpack_public_path__ + "assets/icon-receipt-long.e8ccd708.webp";